import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

// Paths where standard site chrome (nav, footer, whatsapp) is hidden for
// immersive / cinematic experiences.
const IMMERSIVE_PATHS = [
  "/products/eco-packaging/experience",
];

export function AppNavbar() {
  const { pathname } = useLocation();
  if (IMMERSIVE_PATHS.some((p) => pathname.startsWith(p))) return null;
  return <Navbar />;
}

export function AppFooter() {
  const { pathname } = useLocation();
  if (IMMERSIVE_PATHS.some((p) => pathname.startsWith(p))) return null;
  return <Footer />;
}

export function AppWhatsApp() {
  const { pathname } = useLocation();
  if (IMMERSIVE_PATHS.some((p) => pathname.startsWith(p))) return null;
  return <WhatsAppButton />;
}
